import ScreenSlider from './ScreenSlider'

export default ScreenSlider
